
import { defineComponent, SetupContext } from 'vue';

interface SetupReturn {
    setFeedbackType(type: string): void;
}

export default defineComponent({
    setup(_, { emit }: SetupContext): SetupReturn {
        const setFeedbackType = (type: string): void => {
            emit('select-feedback-type', type);
            emit('next');
        };

        return {
            setFeedbackType,
        };
    },
});
